import ProgressOverviewComponent from '../../components/ProgressOverviewComponent'
import CourseEngagementChart from './course-engagement-chart/india'
import CourseSummaryTable from './course-summary-table'

function Progress() {
    return (
        <main>
            <ProgressOverviewComponent />

            {/* mini table for course summary */}
            <CourseSummaryTable />

            {/* course engagement chart */}
            <CourseEngagementChart />
        </main>
    )
}

export default Progress